import axiosInstance from "./axiosInstance";
import portalAxiosInstance from "./portalAxiosInstance";

const PortalAuthService = {
    // CRM user sends invite (uses internal axiosInstance)
    invite: (data) => axiosInstance.post('/api/portal/auth/invite', data).then(r => r.data),

    // CRM user checks portal status of a customer (uses internal axiosInstance)
    getPortalStatus: (customerId) => axiosInstance.get(`/api/portal/auth/status/${customerId}`).then(r => r.data),

    // Public — set up account from invite token
    setupAccount: (data) => portalAxiosInstance.post('/api/portal/auth/setup', data).then(r => r.data),

    // Public — portal login
    login: (data) => portalAxiosInstance.post('/api/portal/auth/login', data).then(r => r.data),

    // Portal JWT protected — mint a token scoped to another membership ("switch company")
    switchCompany: (customerId) => portalAxiosInstance.post('/api/portal/auth/switch', { customerId }).then(r => r.data),

    // Portal JWT protected — get current portal user
    me: () => portalAxiosInstance.get('/api/portal/me').then(r => r.data),
};

export default PortalAuthService;
